module.exports = __webpack_public_path__ + "img/eldi-ypekky.81bf5a75.svg";